import { render } from "./all-pilihan-ganda.vue?vue&type=template&id=3717249b&scoped=true"
import script from "./all-pilihan-ganda.vue?vue&type=script&lang=js"
export * from "./all-pilihan-ganda.vue?vue&type=script&lang=js"

import "./all-pilihan-ganda.vue?vue&type=style&index=0&id=3717249b&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3717249b"]])

export default __exports__